<h4 class="font-bold" style="font-size: 18px">{{ 'importCatalog.catalogTitle' | translate }}</h4>

<p-card>
  <div class="grid mb-2">
    <div class="col-3">
      @if (!isHistoryTabActive) {
      @if (isOperator || isSuperAdmin() ) {
      <p-select [(ngModel)]="selectedShop" [options]="shops" (ngModelChange)="onShopChange($event)" class="w-full"
        [disabled]="shops?.length <= 1">
        <ng-template let-shop pTemplate="item">
          <div>
            <span class="font-bold">{{ shop.shopName }}</span>
            <span>{{" - "}}{{ shop.shopChannel.channelName | translate}}</span>
          </div>
        </ng-template>
        <ng-template let-selectedItem pTemplate="selectedItem">
          <p class="inline font-bold line-height-1">
            {{ selectedShop.shopName + " - " }}
          </p>
          <p class="inline line-height-1">
            {{ selectedShop.shopChannel.channelName | translate}}
          </p>
        </ng-template>
      </p-select>
      }@else {
      <p-select [(ngModel)]="selectedFilteredShop" [options]="filteredShops" (ngModelChange)="onShopChange($event)"
        class="w-full" [disabled]="filteredShops?.length <= 1">
        <ng-template let-shop pTemplate="item">
          <div>
            <span class="font-bold">{{ shop.shopName }}</span>
            <span>{{" - "}}{{ shop.shopChannel.channelName | translate}}</span>
          </div>
        </ng-template>
        <ng-template let-selectedItem pTemplate="selectedItem">
          <p class="inline font-bold line-height-1">
            {{ selectedFilteredShop.shopName + " - " }}
          </p>
          <p class="inline line-height-1">
            {{ selectedFilteredShop.shopChannel.channelName | translate}}
          </p>
        </ng-template>
      </p-select>
      }
      
      } @else if (!isOperator && !isSuperAdmin() ) {
      <p-select [(ngModel)]="selectedShop" [options]="shops" (ngModelChange)="onShopChange($event)" class="w-full"
        [disabled]="shops?.length <= 1">
        <ng-template let-shop pTemplate="item">
          <div>
            <span class="font-bold">{{ shop.shopName }}</span>
            <span>{{ " - "}}{{ shop.shopChannel.channelName | translate}}</span>
          </div>
        </ng-template>
        <ng-template let-selectedItem pTemplate="selectedItem">
          <p class="inline font-bold line-height-1">
            {{ selectedShop.shopName + " - " }}
          </p>
          <p class="inline line-height-1">
            {{ selectedShop.shopChannel.channelName | translate}}
          </p>
        </ng-template>
      </p-select>
      }
      </div>
    @if(isHistoryTabActive) {
      <div class="col-9 text-right">
        <p-button [outlined]="true" (onClick)="showExportDialog()">
          <i class="pi pi-upload"></i>
          <span class="pl-2">{{'buttons.export' | translate}}</span>
        </p-button>
      </div>
    }
  </div>
<p-tabs [value]="selectedTabIndex" (valueChange)="onTabChange($event)">
  <p-tablist>
    @for (tab of tabs; track $index) {
      <p-tab [value]="$index">{{ tab.label | translate }}</p-tab>
    }
  </p-tablist>

  <p-tabpanels>
    @for (tab of tabs; track $index) {
      <p-tabpanel [value]="$index">
        @if (tab.componentTxt === "history") {
          @if (isHistoryTabActive) {
            <app-import-history
              [status]="[]"
              [showErrors]="true"
              #importHistoryComponent
              [hideFilters]="false"
              [hideSearch]="false"
              [hasNext]="hasNext"
              [aggregators]="aggregators"
              [shopsFilters]="exportShops">
            </app-import-history>
          }
        } @else {
          <app-import-file
            #importFileComponent
            [hasNext]="hasNext"
            [shops]="filteredShops"
            [hideImportModule]="hideImportModule"
            [shopsFilters]="exportShops">
          </app-import-file>
        }
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
</p-card>
<p-dialog [header]="'importHistory.exportImportHistory' | translate" [(visible)]="visible" [style]="{ width: '28rem' }" (onHide)="closeExportModal()">
  @if(selectedExportOption === 'shop') {
    <span class="p-text-secondary block mb-5">{{'importHistory.exportFileMessage' | translate}}</span>
  }@else {
    <span class="p-text-secondary block mb-5">{{'importHistory.exportFileAggMessage' | translate}}</span>
  }
  
  @if(loading) {
    <div class="flex justify-content-center mt-5">
      <p-progressSpinner  [style]="{width: '50px', height: '50px'}" class="custom-spinner"></p-progressSpinner>
    </div>
   
  }@else {
    <div class="formgrid grid ">
        <div class="field col-5">
          <label class="mb-3 mt-1 pt-1">{{'importHistory.exportWithAggregator' | translate}}</label>
        </div>
        <div class="field col-7">
          <p-selectButton 
            [options]="exportOptions" 
            [(ngModel)]="selectedExportOption" 
            optionLabel="label" 
            optionValue="value">
            </p-selectButton>       
        </div>
      </div>
      @if(selectedExportOption === 'aggregator') {
        <div class="stepper-aggregator flex gap-3 mb-5">
          <p-stepper [value]="activeStep">
            <p-step-item [value]="1">
              <p-step>{{ 'importHistory.chooseAggregator' | translate }}</p-step>
              <p-step-panel>
                <ng-template pTemplate="content" let-activateCallback="activateCallback">
                  <p-listbox
                    [options]="aggregators"
                    [(ngModel)]="selectedAggregator"
                    optionLabel="name"
                    [style]="{ width: '20rem' }"
                    [multiple]="false"
                    [filter]="true"
                    [filterPlaceHolder]="'settings.searchShop' | translate"
                    [metaKeySelection]="false"
                    [listStyle]="{ 'max-height': '220px' }"
                    [showToggleAll]="false"
                  />
                  <div class="flex py-4">
                    <p-button [label]="'buttons.next' | translate" (onClick)="activateCallback(2)" />
                  </div>
                </ng-template>
              </p-step-panel>
            </p-step-item>

            <p-step-item [value]="2">
              <p-step>{{ 'importHistory.chooseDate' | translate }}</p-step>
              <p-step-panel>
                <ng-template pTemplate="content" let-activateCallback="activateCallback">
                  <div class="mt-3">
                    <p-datepicker
                      appendTo="body"
                      [showIcon]="true"
                      [placeholder]="'filters.enterStartDate' | translate"
                      [(ngModel)]="exportAggregatorStartDate"
                      dateFormat="dd/mm/yy"
                      [readonlyInput]="true"
                      [showTime]="true"
                      [showButtonBar]="true"
                      [maxDate]="maxDate"
                      (ngModelChange)="onDateSelect('start', $event)"
                    />
                    <div class="h-1rem"></div>
                    <p-datepicker
                      appendTo="body"
                      [showIcon]="true"
                      [placeholder]="'filters.enterEndDate' | translate"
                      [(ngModel)]="exportAggregatorEndDate"
                      dateFormat="dd/mm/yy"
                      [readonlyInput]="true"
                      [showTime]="true"
                      [showButtonBar]="true"
                      [minDate]="minDate"
                      (ngModelChange)="onDateSelect('end', $event)"
                    />
                  </div>
                  <div class="flex py-4 gap-2">
                    <p-button [label]="'buttons.back' | translate" severity="secondary" (onClick)="activateCallback(1)" />
                  </div>
                </ng-template>
              </p-step-panel>
            </p-step-item>
          </p-stepper>
       
        </div>
      }@else {
        <div class="align-items-center mb-2 ml-1">
          <p-iconField iconPosition="left" class="w-full">
            <p-inputIcon styleClass="pi pi-search" />
            <input
              type="text"
              pInputText
              (keydown.enter)="onFilter($event)"
              placeholder="{{ 'settings.searchShop' | translate }}"
              class=""
            />
          </p-iconField>
        </div>
        <div class="flex align-items-center gap-3 mb-3 ml-1">
          <p-listbox
          [options]="exportShops"
          [(ngModel)]="selectedExportShop"
          optionLabel="shopNameWithChannel"
          [style]="{ width: '22rem' }"
          [multiple]="false"
          [metaKeySelection]="false"
          [listStyle]="{ 'max-height': '220px' }"
          [showToggleAll]="false"
        />
        </div>
        <div class="pagination-controls align-items-center mb-5 pl-3" [style]="{ width: '22rem' }">
          <div class="page-buttons">
            <p-button 
              icon="pi pi-chevron-left" 
              (onClick)="previousPage()" 
              [disabled]="currentPage === 0"></p-button>
            <p-button 
              icon="pi pi-chevron-right" 
              (onClick)="nextPage()" 
              [disabled]="!hasNext"></p-button>
          </div>
        </div>
      }
    
  }

 
  <div class="flex justify-content-end gap-2">
      <p-button [label]="'buttons.cancel' | translate" severity="secondary" (onClick)="closeExportModal()" />
      <p-button [label]="'buttons.export' | translate" (onClick)="exportImportHistory()"  [disabled]="loading || (selectedExportOption === 'shop' && !selectedExportShop) || (selectedExportOption === 'aggregator' && (!selectedAggregator || !exportAggregatorStartDate || !exportAggregatorEndDate))"/>
  </div>
</p-dialog>